
import { css } from 'lit';
export default css`
.breadcrumb {
  display: flex;
  list-style-type: none;
  flex-wrap: wrap;
  align-items: flex-start;
}

  .breadcrumb__item {
  position: relative;
}

  .breadcrumb__item {
  padding-right: 1.5rem;
}

  .breadcrumb__item {
  font-weight: 700;
}

  .breadcrumb__item {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

  .breadcrumb__item {
    word-break: break-word;
  }

  @media (min-width: 360px) {

  .breadcrumb__item {
      max-width: 50%
  }
    }

  .breadcrumb__item:not(:last-child)::after {
  position: absolute;
}

  .breadcrumb__item:not(:last-child)::after {
  top: 0.25rem;
}

  .breadcrumb__item:not(:last-child)::after {
  right: 0.75rem;
}

  .breadcrumb__item:not(:last-child)::after {
  height: 1rem;
}

  .breadcrumb__item:not(:last-child)::after {
  width: 1px;
}

  .breadcrumb__item:not(:last-child)::after {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

  .breadcrumb__item:not(:last-child)::after {
  font-weight: 700;
}

  .breadcrumb__item:not(:last-child)::after {
      content: ' ';
      transform: rotate(13deg);
    }

  .breadcrumb__item:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

  .breadcrumb__item:hover {
  text-decoration: underline;
}

  .breadcrumb__item:last-child {
  padding-right: 0px;
}

  .breadcrumb__item:last-child {
  font-weight: 400;
}

  .breadcrumb__item:last-child:hover {
  text-decoration: none;
}

  @media (min-width: 360px) {

  .breadcrumb__item:first-child {
        max-width: unset
    }
      }

  .breadcrumb__item--white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .breadcrumb__item--white:not(:last-child)::after {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

  .breadcrumb__item--white:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .breadcrumb__item--purple {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .breadcrumb__item--purple:not(:last-child)::after {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

  .breadcrumb__item--purple:hover {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .breadcrumb__item--purple:last-child {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

  .breadcrumb__link {
  display: inline-block;
}

  .breadcrumb__link {
  border-bottom-width: 1px;
}

  .breadcrumb__link {
  border-color: transparent;
}

  .breadcrumb__link {
  font-family: Lato, sans-serif;
}

  .breadcrumb__link {
  font-weight: 700;
}

  .breadcrumb__link {
  line-height: 1.25;
}

  .breadcrumb__link {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .breadcrumb__link {
  text-decoration: none;
}

  .breadcrumb__link:last-child {
  font-weight: 400;
}

  .breadcrumb__link:focus {
  --tw-border-opacity: 1;
  border-color: rgba(35, 35, 35, var(--tw-border-opacity));
}

  .breadcrumb__link:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

  .breadcrumb__link:hover {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

  .breadcrumb__link--white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .breadcrumb__link--white:hover {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}

  .breadcrumb__link--white:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .breadcrumb__link--purple {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .breadcrumb__link--purple:hover {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

  .breadcrumb__link--purple:hover {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
`;